import { useRef, useState } from "react";
import { Form } from "./Form";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
import { EmptyExtCalling, IVRUserList, Table } from "./Table";

export interface IModal {
    singleData: IVRUserList,
    open: boolean
}

export const IVRsUserList = (permissions: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyExtCalling, open: false });
    };

    return (
        <>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}